import * as React from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { List, ListItem } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { INeighborhood } from "../../services/backend/NeighborhoodService";
import routes from "../../components/routing/Routes";

export interface Props {
  title: string;
  neighborhoodData: INeighborhood | undefined;
  open: boolean;
  onClose: () => void;
}

export const GameServerNeighborhoodData = ({ title, neighborhoodData, onClose, open }: Props) => {
  const navigate = useNavigate();

  const navigateToNeighborhoodDataEntity = () => {
    const params = createSearchParams({ data_structure: "Neighborhood", id: neighborhoodData?.id || "" });
    const route = `${routes.dataEntityEditor}?${params.toString()}`;

    navigate(route);
  };

  return (
    <React.Fragment>
      <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <List>
            <ListItem>ID: {neighborhoodData?.id}</ListItem>
            <ListItem>Name: {neighborhoodData?.name}</ListItem>
            <ListItem>Persistent Action Container ID: {neighborhoodData?.persistentActionContainerId}</ListItem>
            <ListItem>Placed Object Container ID: {neighborhoodData?.placedObjectContainerId}</ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={navigateToNeighborhoodDataEntity}>
            Go to Neighborhood Data
          </Button>
          <Button autoFocus color="error" onClick={onClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
